import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)


// async function refreshToken(){
//    await window.Store.dispatch("refreshToken")
//     .then(response => {
//       this.Answer = response;
//     })
//     .catch(errors => {
//       this.Answer = errors;
//     });
// }

// refreshToken();

const ifNotAuthenticated = (to, from, next) => {
  const Login = JSON.parse(sessionStorage.getItem("TPSession"));
  if (!Login) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  const Login = JSON.parse(sessionStorage.getItem("TPSession"));
  if (Login) {
    next()
    return
  }
  next('/loginpage')
}

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "about" */ '@/views/Dashboard.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/loginpage',
    name: 'loginpage',
    component: () => import(/* webpackChunkName: "about" */ '@/views/LoginPage.vue'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/resetpassword',
    name: 'resetpassword',
    component: () => import(/* webpackChunkName: "about" */ '@/views/ResetPassword.vue'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/Invoices',
    name: 'Invoices',
    component: () => import('@/views/InvoicesPage.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/NewComplaint',
    name: 'NewComplaint',
    component: () => import(/* webpackChunkName: "about" */ '@/views/NewComplaintPage.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/ComplaintsList',
    name: 'ComplaintsList',
    component: () => import(/* webpackChunkName: "about" */ '@/views/ComplaintsListPage.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/ProductionTerms',
    name: 'ProductionTerms',
    component: () => import(/* webpackChunkName: "about" */ '@/views/ProductionTerms.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/Downloads',
    name: 'Downloads',
    component: () => import(/* webpackChunkName: "about" */ '@/views/Downloads.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: "/404",
    name: "404",
    meta: { title: "Not Found" },
    component: () => import(/* webpackChunkName: "errors-404" */ "@/views/NotFound.vue")
  },
]

const router = new VueRouter({
  routes, // short for routes: routes
  linkExactActiveClass: "active",
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  }
});


export default router;

